import { FC } from 'react';
import { useRouter } from 'next/router';
import { List } from 'antd';

import SpinC from 'src/components/Layout/Spin';
import { Title } from 'src/components/Layout/Typography';
import useMostSearchArticle from 'src/hooks/useMostSearchArticle';
import { IArticleByGroupDetail } from 'src/interface';
import { formatQueryParams } from 'src/utils/func';

import classes from './style.module.css';

const TabMostSearch: FC = () => {
	const router = useRouter();
	const tabQuery = router.query?.layout ? { layout: router.query.layout } : {};
	const { data, isLoading } = useMostSearchArticle();

	return (
		<>
			<Title level={2} text="Pencarian Obat Banyak Dicari" className={classes.title} />
			<div className={classes.result}>
				{!isLoading ? (
					<List
						grid={{ gutter: 16, xs: 2, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
						dataSource={data ?? []}
						renderItem={(item: IArticleByGroupDetail, i: number) => (
							<List.Item key={i}>
								<a href={`/obat/${item.url}${formatQueryParams(tabQuery)}`}>
									<Title level={3} text={item.title} className="fs-16 fw-400" />
								</a>
							</List.Item>
						)}
					/>
				) : (
					<SpinC />
				)}
			</div>
		</>
	);
};

export default TabMostSearch;
